// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carouseNew-module_carouselContainer__L1lvn {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    position: relative;
    cursor: grab;
}

.carouseNew-module_carouselContainer__L1lvn:active {
    cursor: grabbing;
}

.carouseNew-module_sliderTrack__Zeaem {
    display: flex;
    transition: transform 0.5s ease-in-out;
}

.carouseNew-module_slideWrapper__Tx3xc {
    flex-shrink: 0;
    box-sizing: border-box;
}

.carouseNew-module_dotGroup__b4_C8 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.carouseNew-module_dotGroup__b4_C8 button {
    background-color: var(--grey_16_lc);
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    height: 8px;
    width: 8px;
}

.carouseNew-module_dotGroup__b4_C8 button:disabled {
    background-color: var(--purple_100);
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Carousel/carouseNew.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mCAAmC;IACnC,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,eAAe;AACnB","sourcesContent":[".carouselContainer {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: hidden;\n    position: relative;\n    cursor: grab;\n}\n\n.carouselContainer:active {\n    cursor: grabbing;\n}\n\n.sliderTrack {\n    display: flex;\n    transition: transform 0.5s ease-in-out;\n}\n\n.slideWrapper {\n    flex-shrink: 0;\n    box-sizing: border-box;\n}\n\n.dotGroup {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n\n.dotGroup button {\n    background-color: var(--grey_16_lc);\n    padding: 0;\n    cursor: pointer;\n    border-radius: 50%;\n    height: 8px;\n    width: 8px;\n}\n\n.dotGroup button:disabled {\n    background-color: var(--purple_100);\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `carouseNew-module_carouselContainer__L1lvn`,
	"sliderTrack": `carouseNew-module_sliderTrack__Zeaem`,
	"slideWrapper": `carouseNew-module_slideWrapper__Tx3xc`,
	"dotGroup": `carouseNew-module_dotGroup__b4_C8`
};
export default ___CSS_LOADER_EXPORT___;
